export type EquipmentDmgFilterType = {
  key?: string;
  status?: string;
  isMultiple?: boolean;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
};

export enum EquipmentLocalStorage {
  KEY = 'equipmentFilterKey',
  STATUS = 'equipmentFilterStatus',
  IS_MULTIPLE = 'equipmentFilterIsMultiple',
}
